import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

import { Tooltip, CardSelection, EmptyState } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";
import {
  AcademicHonestyIllustration,
  GoalIllustration,
  fontStyles,
} from "@toddle-edu/ds-theme";
import { useI18n } from "Hooks";

import classes from "./CardView.scss";

const styles = {
  overlayInnerStyle: {
    maxWidth: "278px",
  },
  cardContainerStyle: {
    width: "280px",
  },
  emptyTitleStyle: {
    ...fontStyles.demiBold,
  },
};

const CardView = props => {
  const {
    value,
    unitSpecificData,
    globalData,
    showAllLearningGoals,
    updateInputField,
    testId,
    fieldLabel,
    emptyStateSecondaryButton,
    getLearningGoalsTagCountTooltip,
    shouldUpdateActiveQuestionOnClick,
  } = props;

  const { t } = useI18n();

  const { nodes } = showAllLearningGoals ? globalData : unitSpecificData;

  const handleCardClick = id => {
    if (_.includes(value, id)) {
      updateInputField(_.filter(value, val => val !== id));
      return;
    }
    updateInputField([...value, id]);
  };

  const getEmptyStateData = () => {
    if (!showAllLearningGoals) {
      return {
        illustration: AcademicHonestyIllustration,
        title: t("classRoom:no_label_selected_in_this_unit", {
          label: fieldLabel,
        }),
        subtitle: null,
        secondaryButton: emptyStateSecondaryButton,
      };
    }
    return {
      illustration: GoalIllustration,
      title: t("classRoom:no_label_to_select_from", {
        label: fieldLabel,
      }),
      subtitle: t("classRoom:no_label_to_select_from_subtext", {
        label: fieldLabel,
      }),
      secondaryButton: null,
    };
  };

  const renderEmptyState = () => {
    const {
      illustration,
      title,
      subtitle,
      secondaryButton,
    } = getEmptyStateData();

    return (
      <div className={classes.emptyStateContainer}>
        <EmptyState
          illustration={illustration}
          title={title}
          subtitle={subtitle}
          titleStyle={styles.emptyTitleStyle}
          secondaryButton={secondaryButton}
        />
      </div>
    );
  };

  const renderSuffixIcon = subText => {
    return !_.isEmpty(subText) ? (
      <Tooltip tooltip={subText} overlayInnerStyle={styles.overlayInnerStyle}>
        <InformationOutlined variant={"subtle"} tabIndex={0} />
      </Tooltip>
    ) : null;
  };

  return _.isEmpty(nodes) ? (
    renderEmptyState()
  ) : (
    <div className={classes.nodesContainer}>
      <div className={classes.container}>
        {_.map(nodes, node => {
          const { id, label, subText } = node;

          return (
            <div
              onClick={e => {
                e?.stopPropagation();
              }}
            >
              <CardSelection
                key={id}
                value={id}
                title={label}
                containerStyle={styles.cardContainerStyle}
                selectedValues={value}
                onCardSelectionClick={() => handleCardClick(id)}
                suffixIcon={renderSuffixIcon(subText)}
                testId={testId}
                suffixElement={getLearningGoalsTagCountTooltip(
                  id,
                  shouldUpdateActiveQuestionOnClick
                )}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

CardView.propTypes = {
  nodes: PropTypes.array,
  isChecked: PropTypes.array,
  handleCardClick: PropTypes.func,
};

CardView.defaultProps = {
  getLearningGoalsTagCountTooltip: _.noop,
  shouldUpdateActiveQuestionOnClick: false,
};

export default CardView;
